<div *ngFor="let rule of arrCombinationRules; let idx = index" class="combination-rule">
    <div class="row">
      <div class="col-lg-11">
        <div class="form-inline">
          <label>{{index + idx + 2}}</label><span *ngIf="!isViewResult">. {{'controlPanel.rules.applicantsMustFulfill' | translate}}</span><span *ngIf="isViewResult">. {{'controlPanel.rules.applicantsMustFulfill' | translate}} <b>{{rule.number_ciriterias}}</b> {{'controlPanel.rules.ofTheFollowing' | translate}} <b>{{rule.rules}}</b></span>
          <input *ngIf="!isViewResult" type="number"
                 class="form-control mx-2"
                 [disabled]="statistic"
                 [(ngModel)]="rule.number_ciriterias">
          <span *ngIf="!isViewResult">{{'controlPanel.rules.ofTheFollowing' | translate}}</span>
          <input *ngIf="!isViewResult" type="text"
                 myNumberOnly
                 class="form-control ml-2"
                 [disabled]="statistic"
                 [(ngModel)]="rule.rules">
        </div>
        <div *ngIf="!isViewResult">
          <div *ngIf="arrResults.length > 0; else application0">
            <div *ngFor="let res of arrResults" >
              <p *ngIf="res.index == idx"><span>{{res.result.length}}</span> {{'controlPanel.criteria.ruleApp' | translate}}</p>
            </div>
          </div>
        </div>
        <p *ngIf="isViewResult"><span>{{rule.applicants_fulfill ? rule.applicants_fulfill : 0}}</span> {{ 'controlPanel.applicantsFulfillRule' | translate }}</p>
        <ng-template #application0>
          <p><span>0</span> {{'controlPanel.criteria.ruleApp' | translate}}</p>
        </ng-template>
        <p *ngIf="rule.must_fill == 0 && isViewResult" [innerHTML]="'controlPanel.ruleNotFulfill' | translate"></p>
        <p *ngIf="rule.must_fill == 1 && isViewResult" [innerHTML]="'controlPanel.ruleHadFulfill' | translate"></p>
        <div *ngIf="!isViewResult" class="form-inline must-rule">
          <input class="form-check-input"
                 type="checkbox"
                 name="mustFill"
                 [disabled]="statistic"
                 [(ngModel)]="rule.must_fill">
          <label class="form-check-label ml-2">
            {{'controlPanel.rules.MustFulfill' | translate}}
          </label>
        </div>
      </div>
      <div class="col-lg-1 text-right" *ngIf="!statistic && arrCombinationRules.length > 1">
        <a class="icon-remove icon-question" (click)="removeThisRule(idx)">
          <i class="fa fa-times-circle" aria-hidden="true"></i></a>
      </div>
    </div>
    <hr *ngIf="!statistic">
  <div *ngIf="!statistic" style="margin-bottom: 10px;" class="action-combination">
    <button class="btn btn-info mr-2" (click)="addCombinationRule()">{{'controlPanel.rules.add combination rule' | translate}}</button>
    <button class="btn btn-success mr-2" (click)="calculateResultsRules()">{{'controlPanel.rules.calculate' | translate}}</button>
    <button *ngIf="!isDemoAd" class="btn btn-primary" (click)="_saveControlPanelSettings()">{{'controlPanel.rules.saveSetting' | translate}}</button>
  </div>
</div>
